import gql from 'graphql-tag'

export const deleteComment = gql`
  mutation ($id: Float!, $workspace_id: Float!) {
    deleteComment(id: $id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`
